import { Injectable } from '@angular/core';

  
   import { WKorSlog } from '../myhome/wkorslog';
   
        
   


Injectable() 
export class SifrDataService {

    serviceVariableWKorSlog: WKorSlog;





}


// WEBPACK FOOTER //
// ./src/app/myservice/sifrdata.ts